import { type ReactNode, useId } from 'react';

import type { IncidentNarrative as Narrative } from './incidentNarratives';

type IncidentNarrativeProps = {
  narrative: Narrative;
  evidence?: ReactNode;
};

type NarrativeSectionProps = {
  title: string;
  text: string;
};

const SECTIONS: readonly { title: string; textOf: (narrative: Narrative) => string }[] = [
  { title: 'What happened', textOf: (narrative) => narrative.whatHappened },
  { title: 'Likely root cause', textOf: (narrative) => narrative.likelyRootCause },
  { title: 'Suggested next step', textOf: (narrative) => narrative.suggestedNextStep },
];

function NarrativeSection({ title, text }: NarrativeSectionProps) {
  const titleId = useId();

  return (
    <section className="diagnostics-detail-section" aria-labelledby={titleId}>
      <h2 id={titleId} className="diagnostics-detail-section-title">
        {title}
      </h2>
      <p className="diagnostics-detail-narrative">{text}</p>
    </section>
  );
}

function IncidentNarrative({ narrative, evidence = null }: IncidentNarrativeProps) {
  const [whatHappened, ...explanation] = SECTIONS;

  return (
    <>
      <NarrativeSection title={whatHappened.title} text={whatHappened.textOf(narrative)} />
      {evidence}
      {explanation.map((section) => (
        <NarrativeSection key={section.title} title={section.title} text={section.textOf(narrative)} />
      ))}
    </>
  );
}

export default IncidentNarrative;
